var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactsColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.43 18.285H22.2825V19.425H23.43V18.285Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.43 13.71H22.2825V14.8575H23.43V13.71Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.43 9.14252H22.2825V10.2825H23.43V9.14252Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.43 4.5675H22.2825V5.715H23.43V4.5675Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2825 17.1375H21.1425V18.285H22.2825V17.1375Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2825 14.8575H21.1425V15.9975H22.2825V14.8575Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2825 12.57H21.1425V13.71H22.2825V12.57Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2825 10.2825H21.1425V11.4225H22.2825V10.2825Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2825 7.995H21.1425V9.14249H22.2825V7.995Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2825 5.71503H21.1425V6.85503H22.2825V5.71503Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1425 15.9975H19.995V17.1375H21.1425V15.9975Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1425 11.4225H19.995V12.57H21.1425V11.4225Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1425 6.85498H19.995V7.99498H21.1425V6.85498Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28495 24H17.715V22.8525H18.8549V1.14H17.715V0H6.28495V1.14H5.13745V22.8525H6.28495V24ZM12 1.14H14.28V2.28H12V1.14ZM9.71245 1.14H10.8525V2.28H9.71245V1.14ZM6.28495 2.28H8.57245V3.4275H15.4275V2.28H17.715V21.7125H6.28495V2.28Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5675 14.8575H15.4275V15.9975H16.5675V14.8575Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4274 11.4225H14.2799V12.57H15.4274V11.4225Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4274 9.14252H14.2799V10.2825H15.4274V9.14252Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4274 15.9975H13.1399V17.1375H15.4274V15.9975Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2799 10.2825H13.1399V11.4225H14.2799V10.2825Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1399 14.8575H10.8524V15.9975H13.1399V14.8575Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8524 10.2825H9.7124V11.4225H10.8524V10.2825Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8524 15.9975H8.57239V17.1375H10.8524V15.9975Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71239 11.4225H8.57239V12.57H9.71239V11.4225Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71239 9.14252H8.57239V10.2825H9.71239V9.14252Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57243 14.8575H7.42493V15.9975H8.57243V14.8575Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99742 15.9975H2.85742V17.1375H3.99742V15.9975Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99742 11.4225H2.85742V12.57H3.99742V11.4225Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99742 6.85498H2.85742V7.99498H3.99742V6.85498Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85746 17.1375H1.70996V18.285H2.85746V17.1375Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85746 14.8575H1.70996V15.9975H2.85746V14.8575Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85746 12.57H1.70996V13.71H2.85746V12.57Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85746 10.2825H1.70996V11.4225H2.85746V10.2825Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85746 7.995H1.70996V9.14249H2.85746V7.995Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85746 5.71503H1.70996V6.85503H2.85746V5.71503Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70995 18.285H0.569946V19.425H1.70995V18.285Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70995 13.71H0.569946V14.8575H1.70995V13.71Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70995 9.14252H0.569946V10.2825H1.70995V9.14252Z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70995 4.5675H0.569946V5.715H1.70995V4.5675Z",
    fill: "#0d0d0d"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsColor);
export default __webpack_public_path__ + "static/media/contacts-color.1f6869efc9f2fd34464c5f9a2f07e793.svg";
export { ForwardRef as ReactComponent };